import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'renewal.eh.insuredDetailsPage.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    lossOccurredAfterChangeEffectiveDate: {
        id: 'renewal.eh.insuredDetailsPage.Loss Occurred After Change Effective Date',
        defaultMessage: 'A loss for this risk occurred on or after the effective date of the change?'
    },
    lossOccurredAfterChangeEffectiveDateYes: {
        id: 'renewal.eh.insuredDetailsPage.Loss Occurred After Change Effective Date.Yes',
        defaultMessage: 'Yes'
    },
    lossOccurredAfterChangeEffectiveDateNo: {
        id: 'renewal.eh.insuredDetailsPage.Loss Occurred After Change Effective Date.No',
        defaultMessage: 'No'
    },
    policyInformation: {
        id: 'renewal.eh.insuredDetailsPage.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lineOfBusiness: {
        id: 'renewal.eh.insuredDetailsPage.Line Of Business',
        defaultMessage: 'Line Of Business'
    },
    periodStartDate: {
        id: 'renewal.eh.insuredDetailsPage.Effective Date',
        defaultMessage: 'Effective Date'
    },
    periodEndDate: {
        id: 'renewal.eh.insuredDetailsPage.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'renewal.eh.insuredDetailsPage.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'renewal.eh.insuredDetailsPage.Risk State',
        defaultMessage: 'Risk State'
    },
    policyType: {
        id: 'renewal.eh.insuredDetailsPage.Policy Type',
        defaultMessage: 'Policy type'
    },
    insuredInfo: {
        id: 'renewal.eh.insuredDetailsPage.Insured Information',
        defaultMessage: 'Insured Information'
    },
    insuredFirstName: {
        id: 'renewal.eh.insuredDetailsPage.insuredInformation.FirstName',
        defaultMessage: 'First Name'
    },
    insuredMiddleName: {
        id: 'renewal.eh.insuredDetailsPage.insuredInformation.M.I.',
        defaultMessage: 'M.I.'
    },
    insuredLastName: {
        id: 'renewal.eh.insuredDetailsPage.insuredInformation.LastName',
        defaultMessage: 'Last Name'
    },
    insuredSuffix: {
        id: 'renewal.eh.insuredDetailsPage.insuredInformation.Suffix',
        defaultMessage: 'Suffix'
    },
    insuredSSN: {
        id: 'renewal.eh.insuredDetailsPage.insuredInformation.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    insuredAddress: {
        id: 'renewal.eh.insuredDetailsPage.Insured Residence Information',
        defaultMessage: 'Insured Residence Address'
    },
    insuredAddressAddressLine1: {
        id: 'renewal.eh.insuredDetailsPage.insuredAddress.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    insuredAddressAddressLine2: {
        id: 'renewal.eh.insuredDetailsPage.insuredAddress.Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    insuredAddressAddressCity: {
        id: 'renewal.eh.insuredDetailsPage.insuredAddress.City',
        defaultMessage: 'City'
    },
    insuredAddressAddressZipCode: {
        id: 'renewal.eh.insuredDetailsPage.insuredAddress.ZipCode',
        defaultMessage: 'Zip Code'
    },
    insuredAddressAddressState: {
        id: 'renewal.eh.insuredDetailsPage.insuredAddress.State',
        defaultMessage: 'State'
    },
    addNewPni: {
        id: 'renewal.eh.insuredDetailsPage.pni.Add New Pni',
        defaultMessage: 'Add New Pni'
    },
    locationCodeHelpText: {
        id: 'renewal.eh.insuredDetailsPage.mailingAndBillingAddress.Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.',
        defaultMessage: 'Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.'
    },
    lossOccurredAfterEffectiveDate: {
        id: "renewal.eh.insuredDetailsPage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    },
    effDate: {
        id: 'endorsement.eh.startChangePage.Renewal Term Effective Date',
        defaultMessage: 'Renewal Term Effective Date'
    }
});
